'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _glamor = require('glamor');

var _light = require('react-syntax-highlighter/dist/light');

var _light2 = _interopRequireDefault(_light);

var _docco = require('react-syntax-highlighter/dist/styles/docco');

var _docco2 = _interopRequireDefault(_docco);

var _gradle = require('highlight.js/lib/languages/gradle');

var _gradle2 = _interopRequireDefault(_gradle);

var _java = require('highlight.js/lib/languages/java');

var _java2 = _interopRequireDefault(_java);

var _javascript = require('highlight.js/lib/languages/javascript');

var _javascript2 = _interopRequireDefault(_javascript);

var _objectivec = require('highlight.js/lib/languages/objectivec');

var _objectivec2 = _interopRequireDefault(_objectivec);

var _xml = require('highlight.js/lib/languages/xml');

var _xml2 = _interopRequireDefault(_xml);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


(0, _light.registerLanguage)('gradle', _gradle2.default);
(0, _light.registerLanguage)('java', _java2.default);
(0, _light.registerLanguage)('javascript', _javascript2.default);
(0, _light.registerLanguage)('objectivec', _objectivec2.default);
(0, _light.registerLanguage)('xml', _xml2.default);

var segmentStyle = _extends({}, _docco2.default, {
  hljs: _extends({}, _docco2.default.hljs, {
    background: 'transparent',
    padding: majorScale(1) + ' ' + minorScale(3)
  })
});

var styles = {
  '& > pre': {
    margin: 0
  }
};

var CodeBlock = function CodeBlock(_ref) {
  var children = _ref.children,
      codeStyle = _ref.codeStyle,
      language = _ref.language,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['children', 'codeStyle', 'language', 'style']);

  return _react2.default.createElement(
    _Pane2.default,
    _extends({}, (0, _glamor.css)(styles), props),
    _react2.default.createElement(
      _light2.default,
      { language: language, style: codeStyle },
      children
    )
  );
};

CodeBlock.propTypes = _extends({}, _Pane2.default.propTypes, _light2.default.propTypes);

CodeBlock.defaultProps = {
  overflow: 'hidden',
  textAlign: 'left',
  tint: true,
  rounded: true,
  border: true,
  textStyle: 'mono',
  language: 'javascript',
  codeStyle: segmentStyle
};

exports.default = CodeBlock;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/CodeBlock.js
// module id = 1120
// module chunks = 0